import SharepointPickerV2 from "./SharepointPickerV2";
export default SharepointPickerV2;
